// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__1AwGq","Label":"BuildControl_Label__1uKF3","Less":"BuildControl_Less__h1PSP","More":"BuildControl_More__3W1JK"};